import { render } from "./AppToolbarTable.vue?vue&type=template&id=5540c12a&ts=true"
import script from "./AppToolbarTable.vue?vue&type=script&lang=ts"
export * from "./AppToolbarTable.vue?vue&type=script&lang=ts"

import "./AppToolbarTable.vue?vue&type=style&index=0&id=5540c12a&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__